import Auth from '@js/plugins/auth';
import Big from 'big.js';
import localForage from 'localforage';
import { createActionHelpers } from 'vuex-loading';
import * as type from '../mutation-types';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const store = localForage.createInstance({
    storeName: `till_summary_${Auth.user().id}`,
    namespaced: true,
});

const Laroute = require('../../laroute');

store.getItem('filters').then(filters => {
    if (filters) {
        state.filters = filters;
    }
});

const state = {
    searchMeta: null,
    filters: [],
    tillSummary: {
        id: null,
        cash_adjustments: [],
        opening_amount: 0,
        closing_amount: 0,
        receipts: [],
        total_sales: 0,
        sales: 0,
        total_rounding: 0,
        sales_filter: {},
        voided_sales_filter: {},
        voided_item: {},
        topup_sales: [],
        fuel_sales: [],
        card_sales: [],
        nets_card_sales: [],
        payment_type: [],
        voided_payment: [],
        sales_refund: [],
        version: null,
        headers: [],
        titles: [],
        tillAttendants: [],
        total_payment: 0,
        loyalty: {},
    },
};

const mutations = {
    [type.SET_TILL_SUMMARY](state, tillSummary) {
        state.tillSummary = tillSummary;
    },

    setSearchMeta(state, meta) {
        state.searchMeta = meta;
    },

    async setFilters(state, filters) {
        state.filters = filters;
        await store.setItem('filters', filters);
    },
};

const getters = {
    hasTillSummary(state) {
        return state.tillSummary.id !== null;
    },

    tillSummary(state) {
        return state.tillSummary;
    },

    staff(state) {
        return state.tillSummary.staff;
    },

    outlet(state) {
        return state.tillSummary.outlet;
    },

    tillList(state) {
        return state.tillSummary.tills;
    },

    tillAttendantList(state) {
        return state.tillSummary.tillAttendants;
    },

    sales_refund() {
        return state.tillSummary.sales_refund;
    },

    fuelRefund() {
        return state.tillSummary.fuel_refund;
    },

    shellNfrList() {
        if (!state.tillSummary.shellNfrList) {
            return [];
        }
        return state.tillSummary.shellNfrList.sort((a, b) =>
            a.name.localeCompare(b.name),
        );
    },

    mogasFuelList() {
        return state.tillSummary.mogasFuelList || [];
    },

    agoFuelList() {
        return state.tillSummary.agoFuelList || [];
    },

    kerosene() {
        return state.tillSummary.kerosene;
    },

    sales() {
        return state.tillSummary.sales;
    },

    totalFuelRounding(state, getters) {
        let totalRefund = 0;
        if (_.isEmpty(state.tillSummary.summary)) {
            const rounding = state.tillSummary.sales_filter.rounding;
            const refund_rounding = Big(getters.sales_refund.rounding);
            totalRefund = Big(rounding).plus(Big(refund_rounding));
        } else {
            totalRefund = state.tillSummary.cash_sales.rounding;
        }

        return totalRefund;
    },

    voidedFuelSales() {
        return state.tillSummary.voided_sales_filter.voided_sales;
    },

    totalFuelVoidedOrders() {
        return state.tillSummary.voided_item.total_voided_order;
    },

    totalnonroyalty() {
        return state.tillSummary.nonroyalty;
    },

    voidedFuelOrders() {
        return state.tillSummary.voided_item.voided_order;
    },

    voidedNonCash() {
        if (_.isEmpty(state.tillSummary.summary)) {
            return {
                voided_sales: 0,
                total_voided: 0,
            };
        }
        return state.tillSummary.voidednoncash;
    },

    voidedTopupEdc() {
        if (_.isEmpty(state.tillSummary.summary)) {
            return {
                voided_sales: 0,
                total_voided: 0,
            };
        }
        return state.tillSummary.voidedtopupedc;
    },

    voidedTopupCash() {
        if (_.isEmpty(state.tillSummary.summary)) {
            return {
                voided_sales: 0,
                total_voided: 0,
            };
        }
        return state.tillSummary.voidedtopupcash;
    },

    voidedFuelCash() {
        if (_.isEmpty(state.tillSummary.summary)) {
            return {
                voided_sales: 0,
                total_voided: 0,
            };
        }
        return state.tillSummary.voidedcash;
    },

    checkVoid() {
        if (_.isEmpty(state.tillSummary.summary)) {
            return false;
        }
        return state.tillSummary.checkvoid;
    },

    version() {
        if (_.isNull(state.tillSummary.version)) {
            return null;
        }

        return state.tillSummary.version;
    },

    topupList() {
        return state.tillSummary.topup_sales;
    },

    partialrefund() {
        return state.tillSummary.partialrefund;
    },

    topupVoidedList() {
        return state.tillSummary.topup_voided_sales;
    },

    fuelList() {
        return state.tillSummary.fuel_sales;
    },

    cardList() {
        return state.tillSummary.card_sales;
    },

    netsCardList() {
        return state.tillSummary.nets_card_sales;
    },

    shellAppList() {
        return state.tillSummary.shellAppList || [];
    },

    cardEDCList() {
        return state.tillSummary.card_edc_sales;
    },

    paymentList() {
        return state.tillSummary.payment_type;
    },

    voidedList() {
        return state.tillSummary.voided_payment;
    },

    drawerOpen() {
        return state.tillSummary.drawerOpen;
    },

    pump_test() {
        return state.tillSummary.pump_test;
    },

    shortOrExtra() {
        return state.tillSummary.shortOrExtra;
    },

    expectedCashAmount() {
        return state.tillSummary.expectedCashAmount;
    },

    negative_transaction() {
        return state.tillSummary.negative_transaction;
    },

    overrun() {
        return state.tillSummary.overrun;
    },

    headers() {
        return state.tillSummary.headers;
    },

    titles() {
        return state.tillSummary.titles;
    },

    cancelled_cart() {
        return state.tillSummary.cancelled_transaction_cart;
    },

    cancelled_item() {
        return state.tillSummary.cancelled_transaction_item;
    },

    cashSales() {
        return state.tillSummary.cash_sales;
    },

    setelSales() {
        if (_.isEmpty(state.tillSummary.setel_sales)) {
            return {
                total: 0,
                amount: 0,
            };
        }
        return state.tillSummary.setel_sales;
    },

    localAccountSales() {
        if (_.isEmpty(state.tillSummary.local_account_sales)) {
            return {
                total: 0,
                amount: 0,
            };
        }
        return state.tillSummary.local_account_sales;
    },

    eWallet() {
        if (_.isEmpty(state.tillSummary.ewallet_payment)) {
            return {
                total: 0,
                amount: 0,
            };
        }
        return state.tillSummary.ewallet_payment;
    },

    eWalletGhl() {
        if (_.isEmpty(state.tillSummary.ewalletghl_payment)) {
            return {
                total: 0,
                amount: 0,
            };
        }
        return state.tillSummary.ewalletghl_payment;
    },

    tngEwallet() {
        if (_.isEmpty(state.tillSummary.tng_ewallet_payment)) {
            return {
                total: 0,
                amount: 0,
            };
        }

        return state.tillSummary.tng_ewallet_payment;
    },

    driveOff() {
        if (_.isEmpty(state.tillSummary.driveoff_payment)) {
            return {
                total: 0,
                amount: 0,
            };
        }

        return state.tillSummary.driveoff_payment;
    },

    shellApp() {
        if (_.isEmpty(state.tillSummary.shellApp)) {
            return {
                total: 0,
                amount: 0,
            };
        }

        return state.tillSummary.shellApp;
    },

    tngRfid() {
        if (_.isEmpty(state.tillSummary.tngRfid)) {
            return {
                total: 0,
                amount: 0,
            };
        }

        return state.tillSummary.tngRfid;
    },

    foodDelivery() {
        if (_.isEmpty(state.tillSummary.foodDelivery)) {
            return {
                total: 0,
                amount: 0,
            };
        }

        return state.tillSummary.foodDelivery;
    },

    subsidy() {
        if (_.isEmpty(state.tillSummary.subsidy_payment)) {
            return {
                total: 0,
                amount: 0,
            };
        }

        return state.tillSummary.subsidy_payment;
    },

    shellVoucher() {
        if (_.isEmpty(state.tillSummary.shell_voucher_payment)) {
            return {
                total: 0,
                amount: 0,
            };
        }

        return state.tillSummary.shell_voucher_payment;
    },

    shell_digital_promotion() {
        return state.tillSummary.shell_digital_promotion;
    },

    shell_digital_offer() {
        return state.tillSummary.shell_digital_offer;
    },

    correction() {
        return state.tillSummary.correction;
    },

    ewalletList() {
        return state.tillSummary.ewallets;
    },

    ewalletGhlList() {
        return state.tillSummary.ewallets_ghl;
    },

    cardIPTSales() {
        return state.tillSummary.card_sales_payment_ipt;
    },

    cardOPTSales() {
        return state.tillSummary.card_sales_payment_opt;
    },

    voucherList() {
        return state.tillSummary.voucher_sales;
    },

    voidedCash() {
        return state.tillSummary.voided_cash;
    },

    receipts() {
        return state.tillSummary.receipts;
    },

    cashInFuel() {
        return state.tillSummary.cashIn;
    },

    safeDrop() {
        return state.tillSummary.safeDrop;
    },

    cashOutFuel() {
        return state.tillSummary.cashOut;
    },

    cstore() {
        return state.tillSummary.cstore;
    },

    promotionList() {
        return state.tillSummary.promotions;
    },

    subsidyList() {
        return state.tillSummary.subsidy;
    },

    totalSubsidy(state, getters) {
        const total = getters.subsidyList
            .map(d => d.amount_sales)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        return {
            amount: Big(total).toFixed(2),
        };
    },

    priceoverride() {
        return state.tillSummary.priceoverride;
    },

    settlements() {
        return state.tillSummary.settlements;
    },

    totalMogas(state, getters) {
        const totalMogas = getters.mogasFuelList
            .map(d => d.amount)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        const totaMogasVolume = getters.mogasFuelList
            .map(d => d.volume)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        return {
            amount: Big(totalMogas).toFixed(2),
            total: Big(totaMogasVolume).toString(),
        };
    },

    totalAgo(state, getters) {
        const totalMogas = getters.agoFuelList
            .map(d => d.amount)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        const totaMogasVolume = getters.agoFuelList
            .map(d => d.volume)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        return {
            amount: Big(totalMogas).toFixed(2),
            total: Big(totaMogasVolume).toString(),
        };
    },

    totalEwallet(state, getters) {
        const total = getters.ewalletList
            .map(d => d.amount_sales)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        return {
            amount: Big(total).toFixed(2),
        };
    },

    totalEwalletGhl(state, getters) {
        const total = getters.ewalletGhlList
            .map(d => d.amount_sales)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        return {
            amount: Big(total).toFixed(2),
        };
    },

    totalSettlement(state, getters) {
        const totalSettlement = getters.settlements
            .map(d => d.sales_amount)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);
        return {
            total_amount: Big(totalSettlement).toFixed(2),
        };
    },

    totalTopup(state, getters) {
        const totalTopup = getters.topupList
            .map(d => d.amount_topup)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        const totalTopupQty = getters.topupList
            .map(d => d.total_topup)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        const totalNonRoyaltyQuantity = Big(
            getters.totalnonroyalty.total_quantity,
        ).plus(Big(totalTopupQty));

        const totalNonRoyaltyAmount = Big(
            getters.totalnonroyalty.total_amount,
        ).plus(Big(totalTopup));

        return {
            amount: Big(totalNonRoyaltyAmount).toFixed(2),
            total: Big(totalNonRoyaltyQuantity).toString(),
        };
    },

    fuelRefundTotal(state, getters) {
        const totalRefund = getters.fuelRefund
            .map(d => d.total_amount)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        return {
            amount: Big(totalRefund).toFixed(2),
        };
    },

    totalFuel(state, getters) {
        const totalFuel = getters.fuelList
            .map(d => d.amount)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        const totalFuelQty = getters.fuelList
            .map(d => d.volume)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        return {
            amount: Big(totalFuel).toFixed(2),
            total: Big(totalFuelQty).toFixed(3),
        };
    },

    totalShellApp(state, getters) {
        const totalShellApp = getters.shellAppList
            .map(d => d.amount)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        return {
            amount: Big(totalShellApp).toFixed(2),
        };
    },

    totalCard(state, getters) {
        const totalCard = getters.cardList
            .map(d => d.amount_card_sales)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        return {
            amount: Big(totalCard).toFixed(2),
        };
    },

    totalNetsCard(state, getters) {
        const totalCard = getters.netsCardList
            .map(d => d.amount_card_sales)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        return {
            amount: Big(totalCard).toFixed(2),
        };
    },

    totalEDCCard(state, getters) {
        const totalCard = getters.cardEDCList
            .map(d => d.amount_card_sales)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        const countCard = getters.cardEDCList
            .map(d => d.total_card_sales)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        return {
            amount: Big(totalCard).toFixed(2),
            total: countCard,
        };
    },

    totalPayment(state, getters) {
        return {
            amount: Big(state.tillSummary.total_payment).toFixed(2),
        };
    },

    totalVoided(state, getters) {
        const totalVoided = getters.voidedList
            .map(d => d.amount)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        return {
            amount: Big(totalVoided).toFixed(2),
        };
    },

    totalFuelSales(state, getters) {
        let totalSalesR = 0;
        if (_.isEmpty(state.tillSummary.summary)) {
            const totalCStore = getters.cstore.total_amount;

            const totalFuel = getters.fuelList
                .map(d => d.amount)
                .reduce((a, b) => Big(a).plus(Big(b)), 0);

            const totalSales = Big(totalCStore).plus(Big(totalFuel));
            totalSalesR = Big(totalSales).plus(
                Big(getters.sales_refund.total_sales),
            );
        } else {
            totalSalesR = state.tillSummary.total_sales;
        }

        return totalSalesR;
    },

    /** Sum total (RM) of voided orders */
    voidedOrders(state, getters) {
        const voidedOrders = getters.nonVoidedReceipts
            .map(r => {
                return r.transaction.order.products
                    .filter(p => p.voided_at !== null)
                    .map(p => Big(p.unit_price).times(p.quantity));
            })
            .filter(voidedOrders => voidedOrders.length)
            .reduce((a, b) => {
                const voidedAmount = b.reduce((a, b) => Big(a).plus(Big(b)), 0);
                return Big(a).plus(Big(voidedAmount));
            }, 0);

        return Big(voidedOrders).toFixed(2);
    },

    totalVoidedOrders(state, getters) {
        return getters.nonVoidedReceipts
            .map(r => {
                let totalVoided = r.transaction.order.products
                    .filter(p => p.voided_at !== null)
                    .map(p => {
                        return parseInt(p.quantity);
                    })
                    .reduce((a, b) => a + b, 0);

                return totalVoided;
            })
            .reduce((a, b) => a + b, 0);
    },

    cancelledOrders(state, getters) {
        const cancelledOrders = getters.nonVoidedReceipts
            .map(r => {
                return r.transaction.order.products
                    .filter(p => p.cancelled_at !== null)
                    .map(p => Big(p.unit_price).times(p.quantity));
            })
            .filter(cancelledOrders => cancelledOrders.length)
            .reduce((a, b) => {
                const cancelledAmount = b.reduce(
                    (a, b) => Big(a).plus(Big(b)),
                    0,
                );
                return Big(a).plus(Big(cancelledAmount));
            }, 0);

        return Big(cancelledOrders).toFixed(2);
    },

    totalCancelledOrders(state, getters) {
        return getters.nonVoidedReceipts
            .map(r =>
                r.transaction.order.products
                    .filter(p => p.cancelled_at !== null)
                    .map(p => {
                        return parseInt(p.quantity);
                    })
                    .reduce((a, b) => a + b, 0),
            )
            .reduce((a, b) => a + b, 0);
    },

    nonVoidedReceipts(state, getters) {
        return getters.receipts.filter(r => r.voided_at === null);
    },

    voidedReceipts(state, getters) {
        return getters.receipts.filter(r => r.voided_at !== null);
    },

    voidedSales(state, getters) {
        return getters.voidedReceipts
            .map(r => {
                return r.total_amount;
            })
            .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
    },

    totalVoidedSales(state, getters) {
        return getters.voidedReceipts.length;
    },

    totalSales(state, getters) {
        return getters.nonVoidedReceipts
            .map(r => {
                return r.total_amount;
            })
            .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
    },

    taxes(state, getters) {
        if (state.tillSummary.taxes) {
            return state.tillSummary.taxes;
        }

        return [];
    },

    totalPaymentChannel(state, getters) {
        const totalVoucher = getters.voucherList
            .map(d => d.amount)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        const totalcash = getters.cashSales.amount;

        const totalIPT = getters.cardIPTSales.amount;

        const totalOPT = getters.cardOPTSales.amount;

        const totalSetel = getters.setelSales.amount;

        const totalLocalAccount = getters.localAccountSales.amount;

        const totalEPS = getters.totalEDCCard.amount;

        const grantTotal = Big(totalVoucher)
            .plus(Big(totalcash))
            .plus(Big(totalIPT))
            .plus(Big(totalOPT))
            .plus(Big(totalSetel))
            .plus(Big(totalLocalAccount))
            .plus(Big(totalEPS));

        return {
            total_amount: Big(grantTotal).toFixed(2),
        };
    },

    totalPromotion(state, getters) {
        const totalPayment = getters.promotionList
            .map(d => d.total_amount)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);
        return {
            amount: Big(totalPayment).toFixed(2),
        };
    },

    bhpHighValueItemList() {
        return state.tillSummary.bhpHighValueItemList.sort((a, b) =>
            a.name.localeCompare(b.name),
        );
    },

    bhpLoyalty() {
        return state.tillSummary.bhpLoyalty;
    },

    paymentCollections(state) {
        let channels = state.tillSummary.payment_channel;

        // exclude cash
        return channels.filter(collection => {
            return collection.name !== 'Cash';
        });
    },
};

const actions = {
    getTillSummary({ commit, dispatch }, id) {
        let route = Laroute.route(
            'franchise.report.till_closure.show-tillsummary',
            {
                id,
            },
        );
        startLoading(dispatch, 'fetch-till-summary');

        return axios
            .get(route)
            .then(res => {
                endLoading(dispatch, 'fetch-till-summary');
                commit(type.SET_TILL_SUMMARY, res.data);
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-till-summary');
                throw err;
            });
    },

    getShellTillSummary({ commit, dispatch }, id) {
        let route = Laroute.route(
            'franchise.report.till_closure.show-shell-tillsummary',
            {
                id,
            },
        );
        startLoading(dispatch, 'fetch-till-summary');

        return axios
            .get(route)
            .then(res => {
                endLoading(dispatch, 'fetch-till-summary');
                commit(type.SET_TILL_SUMMARY, res.data);
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-till-summary');
                throw err;
            });
    },

    getBhpTillSummary({ commit, dispatch }, id) {
        let route = Laroute.route(
            'franchise.report.till_closure.show-bhp-tillsummary',
            {
                id,
            },
        );
        startLoading(dispatch, 'fetch-till-summary');

        return axios
            .get(route)
            .then(res => {
                endLoading(dispatch, 'fetch-till-summary');
                commit(type.SET_TILL_SUMMARY, res.data);
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-till-summary');
                throw err;
            });
    },

    getSearchMeta({ commit, dispatch }) {
        const route = Laroute.route('franchise.report.daily_sales.search.meta');

        startLoading(dispatch, 'get-tillmeta');

        return axios
            .get(route)
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-tillmeta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-tillmeta');
                throw err;
            });
    },

    getSearchMetaIfNecessary({ commit, dispatch }) {
        if (!state.searchMeta) {
            return dispatch('getSearchMeta');
        }

        return Promise.resolve(state.searchMeta);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
